import React from "react";
import PropTypes from 'prop-types';
import TextField from "@mui/material/TextField";
import './mui_overrides.scss'
import MenuItem from "@mui/material/MenuItem";
import DatePicker from "@mui/lab/DatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterMomentFns from '@mui/lab/AdapterMoment'

import CheckBox from "@mui/material/Checkbox";
import {Select} from "@mui/material";

export const MuiTextField = (props) => {
    return (
        <TextField
            margin={"normal"}
            fullWidth={true}
            {...props}
        />
    )
}

MuiTextField.propTypes = {
    label: PropTypes.node,
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    error: PropTypes.bool,
    helperText: PropTypes.string,
};

export const MuiSelectOption = ({children, ...props}) => {
    return (
        <MenuItem className={"option"} {...props}>{children}</MenuItem>
    )
}

export const MuiDatePicker = (props) => {
    const {
        error,
        helperText,
        disabled,
        textFieldProps,
        PopperProps: popperPropsFromCaller,
        renderInput: renderInputProp,
        onClose: onCloseFromProps,
        ...rest
    } = props;
    return (
        <LocalizationProvider dateAdapter={AdapterMomentFns}>
            <DatePicker
                allowSameDateSelection
                disabled={disabled}
                error={error}
                PopperProps={{
                    placement: 'bottom-end',
                    ...popperPropsFromCaller,
                }}
                className={"datepicker"}
                inputFormat={"MM/DD/YYYY"}
                {...rest}
                onClose={(...args) => {
                    onCloseFromProps?.(...args);
                }}
                renderInput={(params) => {
                    if (renderInputProp) {
                        const field = renderInputProp(params);
                        return React.cloneElement(field, {
                            onClick: (e) => {
                                field.props.onClick?.(e);
                                if (!disabled) params.onClick?.(e);
                            },
                        });
                    }
                    return (
                        <MuiTextField
                            {...params}
                            {...textFieldProps}
                            error={error}
                            helperText={helperText}
                            onClick={(e) => {
                                textFieldProps?.onClick?.(e);
                                if (!disabled) params.onClick?.(e);
                            }}
                            autoComplete={"off"}
                            InputProps={{
                                ...params.InputProps,
                                ...textFieldProps?.InputProps,
                                endAdornment:
                                    textFieldProps?.InputProps?.endAdornment !== undefined
                                        ? textFieldProps.InputProps.endAdornment
                                        : params.InputProps?.endAdornment,
                            }}
                            inputProps={{
                                ...params.inputProps,
                                readOnly: true,
                            }}
                        />
                    );
                }}
            />
        </LocalizationProvider>
    );
};

export const MuiCheckBox = ({className, ...props}) => {
    return (
        <CheckBox className={`checkbox ${className}`} {...props}/>
    )
}

MuiCheckBox.propTypes = {
    onChange: PropTypes.func,
    checked: PropTypes.bool
};

export const MuiSelect = ({children, ...props}) => {
    return (
        <Select
            fullWidth={true}
            {...props}
        >
            {children}
        </Select>
    )
}
